import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Dashboard from '@/views/Dashboard';
import Devs from '@/views/Devs';
import Djinni from '@/views/Djinni';
import Clients from '@/views/Clients';
import Salary from '@/views/Salary';
import Jobs from '@/views/Jobs';

export default {
  path: '/dashboard',
  component: Dashboard,
  name: 'dashboard',
  beforeEnter: multiguard([ middleware.isLogged ]),
  children: [
    {
      path: 'devs',
      component: Devs,
      name: 'devs',
    },
    {
      path: 'djinni',
      component: Djinni,
      name: 'djinni',
    },
    {
      path: 'clients',
      component: Clients,
      name: 'clients',
    },
    {
      path: 'salary',
      component: Salary,
      name: 'salary',
    },
    {
      path: 'jobs',
      component: Jobs,
      name: 'jobs',
    },
  ]
};
